import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Tab, TabList } from "@similarweb/ui-components";

import I18n from "pro-features/components/WithTranslation/src/I18n";

export const KeywordsTableWrapper = styled.div`
    width: 100%;
    height: 100%;
    background: ${colorsPalettes.carbon[0]};
    overflow: hidden;
`;

export const TabStyled = styled(Tab)`
    .SWReactIcons svg path {
        fill: ${colorsPalettes.carbon[300]};
    }

    &.selected .SWReactIcons svg path {
        fill: ${colorsPalettes.blue[400]};
    }
`;

export const TabText = styled(I18n)`
    margin-left: 12px;
`;
const StyledTabList = styled(TabList)`
    justify-content: space-between;
    width: 100%;
`;

export const CloseButtonWrapper = styled.div`
    position: absolute;
    right: 35px;
    top: 70px;
`;
